export const GoogleSVG = ({
  className,
  size = 22,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 533.5 544.3"
  >
    <path
      d="M533.5 278.4c0-17.3-1.5-34-4.4-50.3H272v95.1h146.9c-6.3 33.7-25.4 62.3-54.4 81.6v67h87.7c51.3-47.3 81.3-117.1 81.3-193.4z"
      fill="#4285f4"
    />
    <path
      d="M272 544.3c73.6 0 135.3-24.4 180.5-66.1l-87.7-67c-24.5 16.4-55.8 26-92.8 26-71.3 0-131.7-48-153.3-112.6h-90.8v70.9C86.8 485.2 173.2 544.3 272 544.3z"
      fill="#34a853"
    />
    <path
      d="M118.9 321.2c-4.9-14.6-7.7-30.1-7.7-46s2.8-31.4 7.7-46V158.3h-90.8C7.1 208 0 242.5 0 272s7.1 64 28.1 113.7l90.8-64.5z"
      fill="#fbbc04"
    />
    <path
      d="M272 107.7c38.9-.6 74.3 13.4 102.1 38.8l76.4-76.4C406.9 24.4 345.2 0 272 0 173.2 0 86.8 59.1 28.1 158.3l90.8 70.9C140.3 155.7 200.7 107.7 272 107.7z"
      fill="#ea4335"
    />
  </svg>
);
